import { customerMarketShopfrontApi, Site } from '@envato/foundation-types'

import { ITopMenuItem } from '../../config/sites/menus/types'
import { IAlertPayload } from '../../typings/alert'
import { IPageSeoMeta } from '../../typings/seoMetadata'
import { ActionTypes, TypeKeys } from '../actions/common'

export interface IState {
  readonly currentSite: Site
  readonly stats: customerMarketShopfrontApi.stats.IResult | null
  readonly baseUrl: string
  readonly menuConfig: ITopMenuItem[]
  readonly alerts: IAlertPayload[]
  readonly errorPage: any
  readonly noIndex: boolean
  readonly seoMeta: IPageSeoMeta
  readonly canonicalPath: string
}

const initialState: IState = {
  currentSite: Site.themeforest,
  stats: null,
  baseUrl: '',
  menuConfig: [],
  alerts: [],
  errorPage: null,
  noIndex: false,
  canonicalPath: '',
  seoMeta: {
    title: 'Envato Market',
    meta_description:
      'Over 3 million digital products created by a global community of designers, developers, photographers, illustrators &amp; producers.'
  }
}

export const reducer = (state = initialState, action: ActionTypes): IState => {
  switch (action.type) {
    case TypeKeys.GET_STATS_SUCCESS:
      return {
        ...state,
        stats: action.payload
      }

    case TypeKeys.SET_CURRENT_SITE:
      return {
        ...state,
        currentSite: action.payload
      }

    case TypeKeys.SET_BASE_URL:
      return {
        ...state,
        baseUrl: action.payload
      }

    case TypeKeys.SET_MENU_CONFIG:
      return {
        ...state,
        menuConfig: action.payload
      }

    case TypeKeys.SHOW_ALERT:
      return {
        ...state,
        alerts: [...state.alerts, action.payload]
      }

    case TypeKeys.HIDE_ALERT:
      const filteredAlerts = state.alerts.slice().filter(alert => {
        return alert.message !== action.payload.message
      })

      return {
        ...state,
        alerts: filteredAlerts
      }

    case TypeKeys.RESET_ALERT:
      return {
        ...state,
        alerts: []
      }

    case TypeKeys.SET_ERROR_PAGE:
      return {
        ...state,
        errorPage: action.payload.id
      }

    case TypeKeys.RESET_ERROR_PAGE:
      return {
        ...state,
        errorPage: null
      }

    case TypeKeys.NO_INDEX:
      return {
        ...state,
        noIndex: true
      }

    case TypeKeys.SET_CANONICAL_PATH:
      return {
        ...state,
        canonicalPath: action.payload
      }

    case TypeKeys.SET_SEO_META:
      return {
        ...state,
        seoMeta: {
          title: action.payload.title || initialState.seoMeta.title,
          meta_description:
            action.payload.meta_description ||
            initialState.seoMeta.meta_description
        }
      }

    default:
      return state
  }
}
